import request from '@/services/interceptor.js'

export const get_utenti_azienda = (aziendaId) => {
    return request({ url: '/superadmin/utenti', method: 'get', params: { aziendaId }, loadingBar: true })
}

export const create_utente_admin = (par) => {
    return request({ url: '/superadmin/utenti', method: 'post', data: par, loadingBar: true })
}

export const update_utente_admin = (id, par) => {
    return request({ url: `/superadmin/utenti/${id}`, method: 'put', data: par, loadingBar: true })
}

export const reset_password_utente = (id, nuovaPassword) => {
    return request({ url: `/superadmin/utenti/${id}/reset-password`, method: 'post', data: { nuovaPassword }, loadingBar: true })
}

export const abilita_utente = (id) => {
    return request({ url: `/superadmin/utenti/${id}/abilita`, method: 'put', loadingBar: true })
}

export const disabilita_utente = (id) => {
    return request({ url: `/superadmin/utenti/${id}/disabilita`, method: 'put', loadingBar: true })
}

export const impersona_utente = (id, motivo) => {
    return request({ url: `/superadmin/utenti/${id}/impersona`, method: 'post', data: { motivo }, loadingBar: true })
}

export const get_storico_impersonazioni = (aziendaId) => {
    return request({ url: '/superadmin/utenti/impersonazioni', method: 'get', params: { aziendaId }, loadingBar: true })
}